exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-aa4386e2] .link_val{margin-bottom:15px}\n", ""]);

// exports
